import React from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../header";
import Footer from "../footer";
import { conciergeServices } from "../../data/conciergeServices";

const ConciergeServicePage = () => {
  const { slug } = useParams();
  const service = conciergeServices.find((item) => item.slug === slug);

  if (!service) {
    return (
      <>
        <Header />
        <section className="min-h-screen flex items-center justify-center px-6 py-24">
          <div className="text-center">
            <h1 className="text-3xl font-semibold text-[#0F172A] mb-3">Service not found</h1>
            <p className="text-gray-600 mb-6">The requested concierge service could not be found.</p>
            <Link to="/concierge" className="text-[#B68A35] font-semibold">
              Return to concierge services
            </Link>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <main className="bg-white text-[#181A20]">
        <section className="relative overflow-hidden bg-[#F8F5EF]">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(24,26,32,0.06),_transparent_30%)]" />
          <div className="max-w-7xl mx-auto px-6 py-24 lg:py-32 relative z-10">
            <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
              <div>
                <p className="text-[#B68A35] font-semibold uppercase tracking-[0.3em] text-sm mb-4 opacity-90">
                  Concierge Service
                </p>
                <h1 className="text-4xl md:text-5xl lg:text-6xl text-[#181A20] leading-tight" style={{ fontFamily: "Pochaevsk" }}>
                  {service.title}
                </h1>
                <p className="text-[#4B5563] text-lg mt-6 leading-8" style={{ fontFamily: "Poppins" }}>
                  {service.intro}
                </p>
                <div className="mt-8 flex flex-wrap gap-4">
                  <Link to="/concierge" className="bg-[#181A20] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#0f1218] transition">
                    Back to Services
                  </Link>
                  <a href="https://wa.me/31644367777" target="_blank" rel="noreferrer" className="border border-[#B68A35] text-[#B68A35] px-6 py-3 rounded-full hover:bg-[#B68A35] hover:text-white transition">
                    Contact Us
                  </a>
                </div>
              </div>
              <div>
                <img src={service.image} alt={service.title} className="w-full h-[420px] object-cover rounded-[32px] shadow-2xl border border-[#ECF1F8]" />
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-[#ECF1F8] text-[#181A20] rounded-[30px] border border-[#181A20]/10 p-10 shadow-lg">
              <h2 className="text-3xl mb-6" style={{ fontFamily: "Pochaevsk" }}>
                Service Overview
              </h2>
              <p className="text-lg leading-8 mb-5" style={{ fontFamily: "Poppins" }}>
                {service.description}
              </p>
              <p className="text-base leading-8 text-[#334155]" style={{ fontFamily: "Poppins" }}>
                Each concierge service is built to remove the uncertainty and administrative burden from your move, purchase, or lifestyle transition in Spain. We pair local expertise with polished coordination so every step feels professional and predictable.
              </p>
            </div>
            <div className="bg-[#181A20] text-[#181A20] rounded-[30px] border border-[#B68A35]/20 p-10 shadow-lg">
              <h2 className="text-3xl mb-6 text-[#fff]" style={{ fontFamily: "Pochaevsk" }}>
                What makes this service different
              </h2>
              <ul className="space-y-4 text-[#fff] text-base" style={{ fontFamily: "Poppins" }}>
                <li className="text-[#fff]">Dedicated guidance for every document, appointment and decision.</li>
                <li className="text-[#fff]">Fast, accurate processing with local Spanish providers.</li>
                <li className="text-[#fff]">Clear communication in English so you always know the next step.</li>
                <li className="text-[#fff]">Flexible support aligned to your property and lifestyle goals.</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-8">
            <div className="bg-[#ECF1F8] text-[#181A20] rounded-[30px] border border-[#181A20]/10 p-10 shadow-lg">
              <h2 className="text-3xl mb-6" style={{ fontFamily: "Pochaevsk" }}>
                How we deliver value
              </h2>
              <div className="space-y-6 text-[#334155]" style={{ fontFamily: "Poppins" }}>
                <p>{service.intro}</p>
                <p>
                  We handle the full process from paperwork review and provider coordination to follow-up support. That means you can stay focused on your property goals while we keep progress moving.
                </p>
                <p>
                  Our team makes sure every step is clear and timed efficiently, with proactive checks so nothing gets delayed or overlooked.
                </p>
              </div>
            </div>
            <div className="grid gap-6 ">
              <div className="bg-[#181A20] text-[#181A20] rounded-[30px] border border-[#B68A35]/20 p-10 shadow-lg">
                <h3 className="text-2xl mb-5 text-[#fff]" style={{ fontFamily: "Pochaevsk" }}>
                  Ideal for clients who need
                </h3>
                <ul className="space-y-3 text-[#ffff] text-base" style={{ fontFamily: "Poppins" }}>
                  <li className="text-[#fff]">Clear direction through Spanish local processes</li>
                  <li className="text-[#fff]">Experienced coordination with authorities and contacts</li>
                  <li className="text-[#fff]">Fast resolution for property and lifestyle services</li>
                </ul>
              </div>
              <div className="bg-[#181A20] text-[#181A20] rounded-[30px] border border-[#B68A35]/20 p-10 shadow-lg">
                <h3 className="text-2xl mb-5 text-[#fff]" style={{ fontFamily: "Pochaevsk" }}>
                  What you can expect to feel
                </h3>
                <ul className="space-y-3 text-[#fff] text-base" style={{ fontFamily: "Poppins" }}>
                  <li className="text-[#fff]">Confident in every step of the process</li>
                  <li className="text-[#fff]">Supported by a reliable local team</li>
                  <li className="text-[#fff]">Ready to move forward without extra stress</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-6 pb-24">
          <div className="grid lg:grid-cols-3 gap-6">
            <div className="bg-white text-[#181A20] rounded-[30px] border border-[#B68A35]/20 p-10 shadow-lg">
              <h3 className="text-2xl mb-4 text-[#B68A35]" style={{ fontFamily: "Pochaevsk" }}>
                Key benefits
              </h3>
              <ul className="space-y-3 text-[#334155] text-base" style={{ fontFamily: "Poppins" }}>
                {service.highlights.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-1 h-2.5 w-2.5 rounded-full bg-[#181A20]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-[#181A20] text-[#181A20] rounded-[30px] border border-[#181A20]/10 p-10 shadow-lg">
              <h3 className="text-2xl text-[#fff] mb-4" style={{ fontFamily: "Pochaevsk" }}>
                Step-by-step support
              </h3>
              <ol className="space-y-4 text-[#fff] text-base" style={{ fontFamily: "Poppins" }}>
                {service.steps.map((step, index) => (
                  <li key={step} className="flex gap-3 text-[#fff]">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#fff] text-[#181A20] flex items-center justify-center font-semibold">
                      {index + 1}
                    </span>
                    <span>{step}</span>
                  </li>
                ))}
              </ol>
            </div>
            <div className="bg-white text-[#181A20] rounded-[30px] border border-[#ECF1F8] p-10 shadow-lg">
              <h3 className="text-2xl mb-4" style={{ fontFamily: "Pochaevsk" }}>
                What you can expect
              </h3>
              <ul className="space-y-3 text-[#334155] text-base" style={{ fontFamily: "Poppins" }}>
                {service.expectations.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-1 h-2.5 w-2.5 rounded-full bg-[#181A20]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ConciergeServicePage;
